import { doc, getDoc, addDoc, collection, getDocs, query, deleteDoc, setDoc,  orderBy, where, updateDoc, limit, getCountFromServer } from "firebase/firestore"
import { db } from "../firebase"

export const getUserDoc = async (uid) => {
  //console.log('%cGetting user Info', 'color:yellow; font-weight:bold;')

  const docRef = doc(db, "users", uid)
  const docSnap = await getDoc(docRef)
  if(docSnap.exists()){
    return(docSnap.data())
  }
  else{
  }
}

export const getUsersDoc = async () =>{
  //console.log('%cGetting all users', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'users'), orderBy('company'))
    const querySnapshot =await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getOrganizerDocs = async () => {
  try {
    const q = query(collection(db, 'users'), where('role', '==', 'organizer'))
    const querySnapshot =await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
} 

export const getStaffDocsWhereEvents = async (event) => {
  try {
    const q = query(collection(db, 'users'), where('role', '==', 'staff'), where('event', '==', event))
    const querySnapshot =await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
} 

export const deleteUserDoc = async (uid) => {
  //console.log('%cDeleting user', 'color:red; font-weight:bold;')
  try {
    await deleteDoc(doc(db, 'users', uid))
  } catch (error) {
    console.log(error)
  }
}

export const checkUserWhereEmail = async (email) => {
  try {
    const q = query(collection(db, 'users'), where('email', '==', email), limit(1))
    const querySnapshot =await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    if(res.length === 0){
      return false
    }else{
      return true
    }
  } catch (error) {
    console.log(error)
  }
}

export const createUserDoc = async (user) => {
  //console.log('%cCreating new user', 'color:green; font-weight:bold;')
  try {
      await setDoc(doc(db, 'users', user.uid),{
      ...user,
      imageUrl:'',
      inactive:false
    })
  } catch (error) {
    console.log(error)
  }
}

export const updateUserImage = async (uid, url) => {
  //console.log('%cUpdating user image', 'color:blue; font-weight:bold;')
  try {
    await updateDoc(doc(db, 'users', uid),{
      imageUrl: url
    })
  } catch (error) {
    console.log(error)
  }
}

export const updateUserDoc = async (uid, newInfo) => {
  try {
    await updateDoc(doc(db, 'users', uid),{
      ...newInfo
    })
  } catch (error) {
    console.log(error)
  }
}

export const disableUserAccount = async (uid, state) => {
  //console.log('%cDisabling user account', 'color:blue; font-weight:bold;')
  try {
    await updateDoc(doc(db,'users', uid),{
      inactive: !state
    })
  } catch (error) {
    console.log(error)
  }
}

export const newOrganizerInvite = async ({name, email})=>{
  //console.log('%cCreating new invite', 'color:green; font-weight:bold;')

  try {
    const docRef = await addDoc(collection(db, 'invites'),{
      name:name, 
      email:email,
      status:'pending',
      role:'organizer'
    })
    return(docRef.id)
  } catch (error) {
    console.log(error)
  }
}

export const newEventDoc = async (event) => {
  //console.log('%cCreating new event', 'color:green; font-weight:bold;')

  const eventData = {
    emailImages:{
      banner:'https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultImages%2FdefaultBanner.png?alt=media&token=c32f1256-1893-45b9-af24-69e38cb5ec26',
      location:'https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultImages%2FdefaultLocation.png?alt=media&token=fc541564-80ec-4829-b8eb-84e5f6000c16',
      footer:'https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultImages%2FdefaultBanner.png?alt=media&token=c32f1256-1893-45b9-af24-69e38cb5ec26'
    },
    footer:'https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultImages%2FdefaultBanner.png?alt=media&token=c32f1256-1893-45b9-af24-69e38cb5ec26',
    form:[
    {title: '', type: 'banner', options: [], required: false, id:'', default:true, imageUrl:'https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultImages%2FdefaultBanner.png?alt=media&token=c32f1256-1893-45b9-af24-69e38cb5ec26'},
    {type: 'title', options: [], title: 'formulario', required: false, id:'', default:true},
    {required: true, title: 'Nombre completo', options: [], type: 'text', id:'name', default:true},
    {options: [], title: 'Empresa', type: 'text', required: true, id:'company', default:true},
    {options: [], title: 'Cargo', required: true, type: 'text', id:'position', default:true},
    {type: 'email', title: 'Dirección de email', options: [], required: true, id:'email', default:true},
    {type: 'text', title: 'Teléfono', options: [], required: true, id:'phone', default:true},
    {type: 'text', title: 'Localidad', options: [], required: true, id:'location', default:true},
    {type:'text', title: 'ID fiscal', options:[], required:true, id:'fiscalId', default:true},
    {type: 'checkbox', title:'Permisos', options: ['Ud da conformidad para que sus datos de contacto sean compartidos con los expositores del evento'], required: false, id:'allowShareData', default:true},
    ]
  }

  try {
    const docRef = await addDoc(collection(db,'events'),{...event, ...eventData})
    return {status:'success', docRef:docRef, eventData: {...event, ...eventData}}
  } catch (error) {
    console.log(error)
  }
}

export const getEventsDoc = async () => {
  //console.log('%cGetting all events', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db,'events'), orderBy('name'))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach(doc => res=[...res, {...doc.data(), id: doc.id}])
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getEventDoc = async (id) => {
  //console.log('%cGetting event doc', 'color:yellow; font-weight:bold;')

  try {
    const docSnap = await getDoc(doc(db,'events', id))
    return docSnap.data()
  } catch (error) {
    console.log(error)
  }
}

export const getEventsDocWhereDate = async () => {
  const date = new Date()
  const today = `${date.getFullYear()-1}`
  //console.log('%cGetting events', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db,'events'), where('date', '>=', today))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach(doc => res=[...res, {...doc.data(), id: doc.id}])
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getEventsDocWhereExhibitor = async (eventNames) =>{
  //console.log('%cGetting events', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'events'), where('name', 'in', [...eventNames]))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach(doc => res=[...res, {...doc.data(), id: doc.id}])
    return res
  } catch (error) {
    console.log(error)
  }
}

export const deleteEventDoc = async (id) => {
  //console.log('%cDeleting event', 'color:red; font-weight:bold;')
  try {
    await deleteDoc(doc(db,'events', id))
  } catch (error) {
    console.log(error)
  }
}

export const updateEventDoc = async (id, event) => {
  //console.log('%cUpdating event', 'color:blue; font-weight:bold;')

  try {
    await updateDoc(doc(db,'events', id),event)
  } catch (error) {
    console.log(error)
  }
}

export const updateEventFormDoc = async (eventId, form, footer) => {
  //console.log('%cUpdating event', 'color:blue; font-weight:bold;')
  try {
    if(footer){
      await updateDoc(doc(db,'events', eventId),{
        form: [...form],
        footer: footer
      })
    }else{
      await updateDoc(doc(db,'events', eventId),{
        form: [...form],
      })
    }
  } catch (error) {
    console.log(error)
  }
}

export const newExhibitorInvite = async (invite) => {
  ////console.log('%cCreating new invite', 'color:green; font-weight:bold;')

  try {
    const docRef = await addDoc(collection(db,'invites'), {...invite, role:'exhibitor', status:'pending'})
    return docRef.id
  } catch (error) {
    console.log(error)
  }
}

export const updateInviteStatus = async (inviteId) => {
  //console.log('%cUpdating invite status', 'color:blue; font-weight:bold;')
  try {
    await updateDoc(doc(db, 'invites', inviteId),{
      status:'accepted'
    })
  } catch (error) {
    console.log(error)
  }
}

export const getStaffWhereExhibitorAndEvent = async (exh, event) => {
  try {
    const q = query(collection(db, 'users'), where('role', '==', 'staff'), where('exhibitor', '==', exh), where('event', '==', event))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id: doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getStaffDocWhereEmail = async (email) => {
  try {
    const q = query(collection(db, 'users'), where('role', '==', 'staff'), where('email', '==', email), limit(1))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id: doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const updateStaffDoc = async (uid, update) => {
  try {
    await updateDoc(doc(db, 'users', uid),{
      ...update
    })
    return {status:'success'}
  } catch (error) {
    return {status: 'failed'}
  }
}

export const getExhibitorsDoc = async () => {
  //console.log('%cGetting all exhibitors', 'color:yellow; font-weight:bold;')

  try {
    const q = query(collection(db, 'users'), where('role', '==', 'exhibitor'))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id: doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getExhibitorsDocWhereEmail = async (email) => {
  //console.log('%cGetting exhibitor', 'color:yellow; font-weight:bold;')

  try {
    const q = query(collection(db, 'users'), where('role', '==', 'exhibitor'), where('email', '==', email), limit(1))
    const querySnapshot = await getDocs(q)
    let res = []

    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id: doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const updateExhibitor = async (id, exhibitor) => {
  //console.log('%cUpdating exhibitor', 'color:blue; font-weight:bold;')
  try {
    await updateDoc(doc(db, 'users', id), exhibitor)
  } catch (error) {
    console.log(error)
  }
}

export const getExhibitorsDocWhereEvent = async (event) =>{
  //console.log('%cGetting exhibitors', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'users'),where('events', 'array-contains', event))
    const querySnapshot = await getDocs(q)
    
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id: doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const countExibitorsDocWhereEvent = async (event) =>{
  try {
    const q = query(collection(db, 'users'), where('role', '==', 'exhibitor'), where('events', 'array-contains', event))
    const querySnapshot = await getCountFromServer(q)
    return(querySnapshot.data().count)
  } catch (error) {
    console.log(error)
  }
}

export const getGroupsDoc = async () =>{
  //console.log('%cGetting all groups', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'groups'))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getGroupDoc = async (groupId) => {
  //console.log('%cGetting all groups', 'color:yellow; font-weight:bold;')
  try {
    const docSnap = await getDoc(doc(db, 'groups', groupId))
    return docSnap.data()
  } catch (error) {
    console.log(error)
  }
} 

export const createGroupDoc = async (group) => {
  //console.log('%cCreating new group', 'color:blue; font-weight:bold;')

  try {
    await addDoc(collection(db, 'groups'), group)
  } catch (error) {
    console.log(error)
  }
}

export const deleteGroupDoc = async (groupId)=>{
  //console.log('%cDeleting group', 'color:red; font-weight:bold;')
  try {
    await deleteDoc(doc(db,'groups', groupId))
  } catch (error) {
    console.log(error)
  }
}

export const updateGroupDoc = async ({id, ...group}) => {
  //console.log('%cUpdating group', 'color:blue; font-weight:bold;')

  try {
    await updateDoc(doc(db,'groups', id), group)
  } catch (error) {
    console.log(error)
  }
}

export const getMeetingGroupDoc = async (exhibitor, event) =>{
  //console.log('%cGetting groups', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'groups'), where('exhibitor', '==', exhibitor), where('event', '==', event), where('type', '==', 'meetings'), limit(1))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach(doc => {
      res = [...res, {...doc.data(), id:doc.id}]
    });
    return(res)
  } catch (error) {
    console.log(error)
    return(error)
  }
}

export const addGuestToGroupDoc = async (groupId, newList) => {
  try {
    await updateDoc(doc(db, 'groups', groupId),{
      guests: [...newList]
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status:'failed'}
  }
}

export const getGroupsDocWhereExhibitor = async (exhibitorId) =>{
  //console.log('%cGetting groups', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'groups'), where('exhibitor.id', '==', exhibitorId))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach(doc => {
      res = [...res, {...doc.data(), id:doc.id}]
    });
    return res
  } catch (error) {
    console.log(error)
    return []
  }
}

export const getGroupsDocWhereExhibitorAndEvent = async (exhibitorId, eventId) =>{
  //console.log('%cGetting groups', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'groups'), where('exhibitor.id', '==', exhibitorId), where('event.id', '==', eventId))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach(doc => {
      res = [...res, {...doc.data(), id:doc.id}]
    });
    return res
  } catch (error) {
    console.log(error)
    return []
  }
}

export const getGroupsDocWhereCompany = async (company) =>{
  //console.log('%cGetting groups', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'groups'), where('exhibitor.company', '==', company))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const deleteGroupsDocWhereExhibitor = async (exhibitorId) => {
  //console.log('%cDeleting groups', 'color:red; font-weight:bold;')
  try {
    const q = query(collection(db, 'groups'), where('exhibitor.id', '==', exhibitorId))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    for(const group of res){
      await deleteDoc(doc(db, 'groups', group.id))
    }
  } catch (error) {
    console.log(error)
  }
}

export const deleteGroupsDocWhereEvent = async (eventId) => {
  //console.log('%cDeleting groups', 'color:red; font-weight:bold;')
  try {
    const q = query(collection(db, 'groups'), where('event.id', '==', eventId))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    for(const group of res){
      await deleteDoc(doc(db, 'groups', group.id))
    }
  } catch (error) {
    console.log(error)
  }
}



export const getInviteDoc = async (id) => {
  //console.log('%cGetting Invite', 'color:yellow; font-weight:bold;')
  try {
    const docSnap = await getDoc(doc(db, 'invites', id))
    return docSnap.data()
  } catch (error) {
    console.log(error)
  }
} 

export const getExhibitorPendingInvitesDoc = async () => {
  //console.log('%cGetting all invites', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'invites'),where('role', '==', 'exhibitor'), where('status', '==', 'pending'))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const deleteInvitesDocWhereExhibitor = async (exhibitorEmail) => {
  //console.log('%cDeleting invites', 'color:red; font-weight:bold;')
  try {
    const q = query(collection(db, 'invites'), where('email', '==', exhibitorEmail))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    for(const invite of res){
      await deleteDoc(doc(db, 'invites', invite.id))
    }
  } catch (error) {
    console.log(error)
  }
}

export const getStaffPendingInviteWhereExhibitor = async (exh ) => {
  try{
    const q = query(collection(db, 'invites'),where('role', '==', 'staff'),where('status', '==', 'pending'), where('sender', '==', exh))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res 
  }catch(error){
    console.log(error)
  }
}

export const getOrganizerPendingInvites = async () => {
  try{
    const q = query(collection(db, 'invites'), where('role', '==', 'organizer'),where('status', '==', 'pending'))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res 
  }catch(error){
    console.log(error)
  }
}

export const checkInvite = async (email, event) => {
  //console.log('%cChecking Invite', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'invites'), where('email', '==', email), where('event.id', '==', event))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    if(res.length===0){
      return false
    }else{
      return true
    }
  } catch (error) {
    console.log(error)
  }
}

export const checkOrganizerInvite = async(email) =>{
  //console.log('%cChecking Invite', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'invites'), where('email', '==', email), where('role', '==', 'organizer'))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    if(res.length===0){
      return false
    }else{
      return true
    }
  } catch (error) {
    console.log(error)
  }
}

export const checkInviteWhereMail = async (email) =>{
  try {
    const q = query(collection(db, 'invites'), where('email', '==', email))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    if(res.length===0){
      return false
    }else{
      return true
    }
  } catch (error) {
    console.log(error)
  }
}

export const checkStaffInviteWhereMailAndEvent = async (email, eventId) =>{
  try {
    const q = query(collection(db, 'invites'), where('role', '==', 'staff'), where('email', '==', email), where('event.id', '==', eventId))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    if(res.length===0){
      return false
    }else{
      return true
    }
  } catch (error) {
    console.log(error)
  }
}

export const createStaffInvite= async(staff)=>{
  try {
    const docRef = await addDoc(collection(db, 'invites'),{...staff, status:'pending', role:'staff'})
    return {status:'success', docRef:docRef}
  } catch (error) {
    console.log(error)
    return {status:'failed', error:error}

  }
}

export const deleteInviteDoc = async (inviteId) => {
  //console.log('%cDeleting invite', 'color:red; font-weight:bold;')
  try {
    await deleteDoc(doc(db, 'invites', inviteId))
  } catch (error) {
    console.log(error)
  }
}

export const createGuestDoc = async (guest) => {
  //console.log('%cCreating new guest', 'color:blue; font-weight:bold;')
  try {
    const docRef = await addDoc(collection(db, 'guests'), {...guest, status:'pending', vip:false, qrUrl:''})
    return docRef.id
  } catch (error) {
    console.log(error)
  }
}

export const getGuestDoc = async (guestId) => {
  //console.log('%cGetting guest doc', 'color:yellow; font-weight:bold;')
  try {
    const res = await getDoc(doc(db, 'guests', guestId))
    return res.data()
  } catch (error) {
    console.log(error)
  }
}

export const deleteGuestDoc = async (guestId) => {
  //console.log('%cDeleting guest', 'color:red; font-weight:bold;')
  try {
    await deleteDoc(doc(db, 'guests', guestId))
  } catch (error) {
    console.log(error)
  }
}

export const deleteGuestsDocWhereEvent = async (eventId) =>{
  //console.log('%cDeleting guest', 'color:red; font-weight:bold;')
  try {
    const q = query(collection(db, 'guests'), where('event', '==', eventId))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    for(const guest of res){
      await deleteDoc(doc(db, 'guests', guest.id))
    }
  } catch (error) {
    console.log(error)
  }
}

export const getGuestsWhereEmailAndEvent = async (email, event) => {
  //console.log('%cGetting guests by email', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'guests'), where('email', '==', email), where('event', '==', event), limit(1))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getGuestsDocWhereEvent = async (eventId) => {
  //console.log('%cGetting all guests', 'color:yellow; font-weight:bold;')
  try {
    const q = query(collection(db, 'guests'), where('event', '==', eventId))
    const querySnapshot = await getDocs(q)
    let res = []
    querySnapshot.forEach((doc)=>{
      res = [...res, {...doc.data(), id:doc.id}]
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const updateGuestDoc = async (guestId, update) => {
  try {
    await updateDoc(doc(db, 'guests', guestId),{
      ...update
    })
  } catch (error) {
    console.log(error)
  }
} 

export const updateGuestStatus = async (guestId) => {
  //console.log('%cUpdating group', 'color:blue; font-weight:bold;')
  try {
    await updateDoc(doc(db, 'guests',guestId ), {
      status: 'confirmed'
    })
  } catch (error) {
    console.log(error)
  }
}

export const updateGuestDocVip = async (guestId, vipState) => {
  //console.log('%cUpdating guest', 'color:blue; font-weight:bold;')
  try {
    await updateDoc(doc(db, 'guests',guestId), {
      vip:vipState
    })
  } catch (error) {
    console.log(error)
  }
}

export const updateGuestDocStatus = async (guestId, status) => {
  //console.log('%cUpdating guest', 'color:blue; font-weight:bold;')
  try {
    await updateDoc(doc(db, 'guests',guestId), {
      status:status
    })
  } catch (error) {
    console.log(error)
  }
}

